import React from 'react';
import ReactDOM from 'react-dom/client';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import './api/apiClient';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const muiTheme = createTheme({
  palette: {
    primary: { main: '#2563eb', dark: '#1d4ed8', light: '#5cd4a0' },
    secondary: { main: '#1d4ed8' },
  },
  shape: { borderRadius: 10 },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider theme={muiTheme}>
      <App />
    </ThemeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
